// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"950f0d64","399":"381a0808","573":"36c2839f","588":"012ee355","683":"05289667","784":"ea6e5a29","787":"bed44058"}[chunkId] + ".chunk.js";
};